import { useCallback } from 'react';

import { FieldValues, SubmitHandler } from 'react-hook-form';

export const useFormSubmit = <TFieldValues extends FieldValues = FieldValues>(
  formSubmit: SubmitHandler<TFieldValues>,
  deps: Array<any>
) => useCallback(formSubmit, deps);
